export default __webpack_public_path__ + "static/media/arrow-forward-dark.66f64915.svg";